export var ConstructionClass;
(function (ConstructionClass) {
    ConstructionClass["Wall"] = "Wall";
    ConstructionClass["Floor"] = "Floor";
})(ConstructionClass || (ConstructionClass = {}));
export var RuConstructionTypeNamesMap = {
    Wall: 'Стены и перегородки',
    Floor: 'Перекрытия',
};
export var RuConstructionTypeSelectValues = [
    { label: 'Стены и перегородки', value: ConstructionClass.Wall },
    { label: 'Перекрытия', value: ConstructionClass.Floor },
];
